import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const differentialCentrifugalSedimentation = {
    jpath: ['spectra', 'differentialCentrifugalSedimentation'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default differentialCentrifugalSedimentation;
//# sourceMappingURL=differentialCentrifugalSedimentation.js.map